import { render, staticRenderFns } from "./AdviceEdit.vue?vue&type=template&id=3c046cef&"
import script from "./AdviceEdit.vue?vue&type=script&lang=js&"
export * from "./AdviceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports